import React, { useEffect, useState } from "react";
import { InputNumber, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useAuth } from "../../../../../contexts/auth";

const ResultCell = ({ record, handleDataChange }) => {
   const auth = useAuth();
   const user = auth.loggedInUser;
   const userRole = user?.role;
  const [isEditing, setIsEditing] = useState(false);
  const reportedValue = record.parameterValue;
  const [value, setValue] = useState(reportedValue);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    handleDataChange(value, record, "parameterValue");
  };

  const handleBlur = () => {
    handleSave();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };

  useEffect(() => {
    setValue(reportedValue);
  }, [reportedValue]);

  return (
     
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      {isEditing ? (
        <InputNumber
          value={value}
          onChange={setValue}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoFocus
          style={{ width: "100%" }}
        />
      ) : (
        <>
          <span style={{ flex: "none", marginRight: 0 }}>
            {record.parameterValue}
          </span>
           {userRole !== "lab_admin" && userRole !== "support_team" && userRole !== "csc_admin" &&(
            <Tooltip title="Edit">
              <EditOutlined
                onClick={handleEditClick}
                style={{
                  marginLeft: 4,
                  color: "#1890ff",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default ResultCell;
